export class ResponseModel {
    statusCode: string;
    statusMsg: string;
    statusRemark: string;
    data: any;
    displayAlert: boolean;
    length :string


    constructor() {
        this.statusCode = '';
        this.statusMsg = '';
        this.statusRemark = '';
        this.data = '';
        this.displayAlert = false;
        this.length='';
    }
}